import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-priorityHighest",
  "use": "icon-priorityHighest-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-priorityHighest\"><path d=\"M128 64a64 64 0 0 0-64 64v768a64 64 0 0 0 64 64h768a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64H128z m383.36 124.16l305.472 305.408-67.84 67.904L560 372.544V832h-96V371.2L273.792 561.536l-67.904-67.84L511.36 188.032z\" fill=\"#DB2C3A\" p-id=\"5038\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol